module.exports = __webpack_public_path__ + "img/light-mud-decal-27.ee7e386e.png";